export default "/_next/static/images/bottom-texture-11-44ca785b6323040490537fc2c62d87a0.svg";